<template>
  <router-view v-resize="onResize"> </router-view>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'App',
  mounted() {
    if (this.$store.getters.companyId) {
      this.$store.dispatch('getCompanyInfo', this.$store.getters.companyId)
    }
  },
  methods: {
    ...mapActions(['setIsMobile']),
    onResize() {
      if (window.innerWidth < 769) {
        this.setIsMobile(true)
      } else {
        this.setIsMobile(false)
      }
    },
  },
}
</script>
